import { AddressComponentTypes } from './../constants/GooglePlaces';

import Utils from './../helpers/Utils';

export interface AddressComponent2 {
  longText: string;
  shortText: string;
  types: string[];
  languageCode: string;
}

export interface Location {
  latitude: number;
  longitude: number;
}

export interface DisplayName {
  text: string;
  languageCode: string;
}

export class GooglePlaceAddress {
  id: string;
  formattedAddress: string;
  addressComponents: AddressComponent2[];
  location: Location;
  displayName: DisplayName;

  constructor() {
    this.id = null;
    this.formattedAddress = null;
    this.addressComponents = null;
    this.location = null;
    this.displayName = null;
  }
}

export class CustomGooglePlaceAddress {
  stateProvince: string;
  city: string;
  latitude: number;
  longitude: number;
  postalCode: string;
  address: string;
  stateProvinceShort?: string;
  locationDetails?: string;
  distanceInKm?: number;
  countryCode?: string;
  country: string;

  constructor(address: GooglePlaceAddress) {
    this.stateProvince = Utils.getGooglePlacesCountryOrStateObjectLongName(address.addressComponents);
    this.stateProvinceShort = Utils.getGooglePlacesCountryOrStateObjectShortName(address.addressComponents);
    this.city = Utils.getGooglePlacesCityLongName(address.addressComponents);
    this.latitude = address.location.latitude;
    this.longitude = address.location.longitude;
    this.postalCode = Utils.getGooglePlacesData(address.addressComponents, [AddressComponentTypes.POSTAL_CODE])?.longText;
    this.country = Utils.getGooglePlacesData(address.addressComponents, [AddressComponentTypes.COUNTRY])?.longText;
    this.countryCode = Utils.getGooglePlacesData(address.addressComponents, [AddressComponentTypes.COUNTRY])?.shortText;
    this.address = address.formattedAddress;
  }

  get addressIsIncomplete(): boolean {
    return (
      !this.stateProvince ||
      !this.stateProvinceShort ||
      !this.city ||
      !this.latitude ||
      !this.longitude ||
      !this.country ||
      !this.countryCode ||
      !this.address
    );
  }
}
